document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('[data-product-gallery]');
  if (gallery) {
    const mainImage = gallery.querySelector('[data-gallery-main]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const count = gallery.querySelector('[data-gallery-count]');
    let activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.getAttribute('aria-pressed') === 'true'));

    const showImage = (index) => {
      if (!mainImage || !thumbs.length) return;
      activeIndex = (index + thumbs.length) % thumbs.length;
      const button = thumbs[activeIndex];
      mainImage.classList.add('is-changing');
      window.setTimeout(() => {
        mainImage.src = button.dataset.src;
        mainImage.srcset = button.dataset.srcset || '';
        mainImage.alt = button.dataset.alt || mainImage.alt;
        mainImage.classList.remove('is-changing');
      }, 120);
      thumbs.forEach((thumb, thumbIndex) => thumb.setAttribute('aria-pressed', String(thumbIndex === activeIndex)));
      button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      if (count) count.textContent = `${activeIndex + 1} / ${thumbs.length}`;
    };

    thumbs.forEach((button, index) => button.addEventListener('click', () => showImage(index)));
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showImage(activeIndex - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => showImage(activeIndex + 1));
    if (count) count.textContent = `${activeIndex + 1} / ${thumbs.length}`;
  }

  const select = document.querySelector('[data-variant-select]');
  const price = document.querySelector('[data-product-price]');
  if (select && price) {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (option?.dataset.price) price.textContent = option.dataset.price;
      const button = select.closest('form')?.querySelector('[type="submit"]');
      if (button) {
        button.disabled = option?.dataset.available !== 'true';
        button.textContent = option?.dataset.available === 'true' ? 'Add to cart' : 'Sold out';
      }
      if (option?.dataset.image) {
        const matchingThumb = Array.from(document.querySelectorAll('[data-gallery-thumb]')).find((thumb) => thumb.dataset.src === option.dataset.image);
        matchingThumb?.click();
      }
    });
    select.dispatchEvent(new Event('change'));
  }

  if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches && 'IntersectionObserver' in window) {
    const items = document.querySelectorAll('.brand-hero__copy, .value-prop, .product-tile, .faq details, .support-path, .support-form-copy, .contact-page__form-wrap, .returns-steps article, .returns-details > div');
    items.forEach((item, index) => {
      item.classList.add('reveal-on-scroll');
      item.style.transitionDelay = `${Math.min(index * 55, 330)}ms`;
    });
    const observer = new IntersectionObserver((entries, instance) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          instance.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -30px' });
    items.forEach((item) => observer.observe(item));
  }
});
